import { createContext, useState } from 'react'

export const AuthContext = createContext()

/**
 * @function AuthProvider will authorize the routes which are being navigated
 * @param props will contain children routes to be authenticated
 */
export const AuthProvider = props => {
  const { children } = props
  const [auth, setAuth] = useState({})

  return <AuthContext.Provider value={{ auth, setAuth }}>{children}</AuthContext.Provider>
}
export default AuthProvider
